import templateUrl from './collapsible-sidebar-shell.html'

/**
 * A component that provides a layout shell with capabilities
 * for hiding the sidebar under specific conditions.
 */
export const CollapsibleSidebarShellComponent = {
    transclude: {
        body: "apexBodyContent",
        sidebar: "apexSidebarContent"
    },
    replace: true,
    bindings: {
        expanded: "<",
        showSidebar: "<",
        sidebarExpandedClass: "@",
        sidebarCollapsedClass: "@",
        bodyExpandedClass: "@",
        bodyCollapsedClass: "@"
    },
    templateUrl: templateUrl
}
